import { useEffect, useState } from "react";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { _RawMaterial, _single } from "../../../../core/services/dataBean/EntityCatalog";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { BasicTable, MASK_MONEY } from "../../../theme/Component/BasicTable";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { Modal } from "../../../theme/Component/Modal";
import { SelectProductEditor } from "../Components/SelectProductEditor";
import { SelectorUmeasurement } from "../../../bpm/config/Componentes/SelectorUmeasurement";
import { InputMoney } from "../../../theme/Input/InputMoney";
import { PrintJson } from "../../../theme/Component/PrintJson";
import { RawMaterialSupplier } from "./RawMaterialSupplier/RawMaterialSupplier";
import { toast } from "react-toastify";

interface Props {
    idManufacturingStardard: number;
}

export const RawMaterial = ({ idManufacturingStardard }: Props) => {

    const { lista, setLista, bean, setBean, instance, update, handleChange, deleteItemVoid } = useDataBean(_RawMaterial);

    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const [modalSupplier, setModalSupplier] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });


    useEffect(() => {
        getLista()
    }, [idManufacturingStardard])

    const getLista = () => {
        instance.getRawMaterialCatalog(idManufacturingStardard).then(
            (rta: any) => {
                setLista(rta)
            }
        ).catch(
            err => { console.log(err) }
        )
    }

    const editaItem = () => {
        update().then(
            (resp) => {
                getLista();
                setModal({ ...modal, "view": false })
            }
        ).catch(
            err => { console.log(err) }
        )
    }

    const deleteObjec = () => {
        deleteItemVoid(bean.IDRawMaterial).then(
            (resp) => {
                getLista();
                setModalC({ ...modalC, "view": false })
            }
        ).catch(
            err => { console.log(err) }
        )
    }

    const head = [
        { title: 'ID', property: 'IDRawMaterial', visible: true },
        { title: 'Nombre del Inventario', property: 'Name', visible: true },
        { title: 'Producto Receta', property: 'ProductName', visible: true },
        { title: 'Código de Referencia-SKU', property: 'StockKeepingUnit', visible: true },
        { title: 'Cantidad', property: 'Quantity', visible: true },
        { title: 'Unidad de Medida', property: 'MeasurementUnitName', visible: true },
        { title: 'Costo Unitario', property: 'UnitaryCost', visible: true, mask: MASK_MONEY },
        { title: 'Empleado', property: 'EmployeeName', visible: true },
    ]

    const create = () => {
        setBean({
            IDEmployee: _single.getAccountID(),
            IDManufacturingStardard: idManufacturingStardard,
        });
        setModal({ ...modal, "view": true, "name": "Agregar Inventario de Materia Prima" });
    }

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { setModal({ ...modal, "view": true, "name": "Editar Inventario de Materia Prima" }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true, "name": `Eliminar Inventario de Materia Prima` }) } },
            { titulo: 'Agregar/Editar Proveedores de Materia Prima', icono: 'ri-shopping-bag-line', visible: true, evento: () => { setModalSupplier({ ...modalSupplier, "view": true, "name": `Agregar/Editar Proveedores de Materia Prima` }) } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const [missingFields, setMissingFields] = useState<string[]>([]);


    return (
        <div className="row">
            <div className="col-md-12">
                <BasicTable listButtons={listaBotones()} head={head} body={lista} rowSet={setBean} iconButtons={iconButtonsItem} />
            </div>


            <div className="col-md-12">
                <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteObjec}>
                    <strong>Eliminar Informacion de {bean.IDIndirectCostType} - {bean.Name}</strong>
                </ModalConfirm>
            </div>

            <div className="col-md-12">
                <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                    <div className="row">
                        <div className="col-md-6">
                            <label className={`${missingFields.includes('IDProduct') ? 'has-error' : ''}`}>Producto Receta</label>
                            <SelectProductEditor label=" " value={bean.IDProduct} onChange={(e) => { setBean({ ...bean, "IDProduct": e.IDProduct, "Name": e.Description, "StockKeepingUnit": e.StockKeepingUnit, "IDMeasurementUnit": e.IDMeasurementUnit, "UnitaryCost": e.ProductCost }); console.log(e) }} />
                            {/* <PrintJson json={bean} /> */}
                        </div>
                        <div className="col-md-6">
                            <label className={`${missingFields.includes('Name') ? 'has-error' : ''}`}>Nombre del Inventario</label>
                            <input type="text" name="Name" className="form-control" value={bean.Name} onChange={handleChange} />
                        </div>


                        <div className="col-md-6">
                            <label className={`${missingFields.includes('StockKeepingUnit') ? 'has-error' : ''}`}>Código de Referencia-SKU</label>
                            <input type="text" name="StockKeepingUnit" className="form-control" value={bean.StockKeepingUnit} onChange={handleChange} />
                        </div>
                        <div className="col-md-6">
                            <label className={`${missingFields.includes('IDMeasurementUnit') ? 'has-error' : ''}`}>Unidad de Medida</label>
                            <SelectorUmeasurement idSelector={bean.IDMeasurementUnit || ''} onChange={(e) => { setBean({ ...bean, "IDMeasurementUnit": e }) }} titulo=" " />
                        </div>
                        <div className="col-md-6">
                            <label className={`${missingFields.includes('UnitaryCost') ? 'has-error' : ''}`}>Costo Unitario</label>
                            <InputMoney _label=" " _value={bean.UnitaryCost} onChange={(e) => { setBean({ ...bean, "UnitaryCost": e }) }} />
                        </div>
                        <div className="col-md-6">
                            <label className={`${missingFields.includes('Quantity') ? 'has-error' : ''}`}>Cantidad</label>
                            <input type="number" name="Quantity" className="form-control" value={bean.Quantity} onChange={handleChange} />
                        </div>
                    </div>
                </Modal>
            </div>

            <div className="col-md-12">
                <Modal modal={modalSupplier} updateModal={setModalSupplier} >
                    <RawMaterialSupplier rawMaterial={bean.IDRawMaterial} />
                </Modal>
            </div>
        </div >
    )
}



